import React from 'react';
import { Shield, Target, TrendingUp, Users } from 'lucide-react';

const principles = [
  {
    icon: Shield,
    keyword: 'Respectvol',
    title: 'Database Protection',
    description: 'Wij bellen respectvol. Je contacten blijven bruikbaar voor de lange termijn.',
  },
  {
    icon: Target,
    keyword: 'Gekwalificeerd',
    title: 'Quality First',
    description: 'Afspraken met mensen die écht geïnteresseerd zijn en komen opdagen.',
  },
  {
    icon: TrendingUp,
    keyword: 'Transparant',
    title: 'Voorspelbaar',
    description: 'Duidelijke rapportage. Je weet wat je kan verwachten.',
  },
  {
    icon: Users,
    keyword: 'Partnership',
    title: 'Langdurig',
    description: 'Samen bouwen aan groei. Partnerships die werken.',
  },
];

const GuaranteesSection = () => {
  return (
    <section className="section bg-gray-900 text-white">
      <div className="container">
        <div className="text-center mb-12">
          <p className="text-brand-blue text-sm font-semibold tracking-wider uppercase mb-2">Onze werkprincipes</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">CONSISTENCY WINS.</h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Hoe wij werken; de principes achter elke samenwerking.
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-6">
          {principles.map((principle, index) => (
            <div
              key={index}
              className="relative p-6 rounded-xl bg-white/5 border border-white/10 hover:border-white/20 transition-all duration-300 hover:bg-white/10"
            >
              <div className="absolute -top-3 -right-3 w-10 h-10 rounded-full bg-brand-blue flex items-center justify-center">
                <principle.icon className="w-5 h-5 text-white" />
              </div>
              <div className="text-2xl font-bold text-blue-400 mb-2">{principle.keyword}</div>
              <h3 className="font-semibold text-white mb-1">{principle.title}</h3>
              <p className="text-sm text-gray-300">{principle.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-gray-400 text-sm">
            Resultaat volgt uit consequente uitvoering.
          </p>
        </div>
      </div>
    </section>
  );
};

export default GuaranteesSection;
